import classNames from 'classnames';

import { useResponsive } from '../../../hooks/useResponsive';
import './ModalFooter.scss';
/**
 * Props for the ModalFooter component.
 */
export interface ModalFooterProps {
  children?: JSX.Element | JSX.Element[];
  className?: string;
}

/**
 * A component that represents the footer of a modal dialog.
 */
export const ModalFooter = ({ children, className }: ModalFooterProps) => {
  const isMobile = useResponsive('down', 'sm');
  return (
    <div
      className={classNames(
        'Mfw-Modal-footer',
        {
          'Mfw-Modal-footer--mobile': isMobile,
        },
        className,
      )}
    >
      {children}
    </div>
  );
};

export default ModalFooter;
